export default __webpack_public_path__ + "static/media/home_logo.de3600d1.gif";